import type { WorkOrderDetailViewModel } from '../../openapi';

export const filterWorkOrderDetails = (
  details: WorkOrderDetailViewModel[],
  allowedEventTypes: string[]
): WorkOrderDetailViewModel[] => {
  const allowedLookup = new Set(
    allowedEventTypes.map(eventType => eventType.trim().toLowerCase())
  );

  return details.filter(item => {
    const hasAllowedEventType = Boolean(
      item.relatedEventType &&
        allowedLookup.has(item.relatedEventType.trim().toLowerCase())
    );

    const hasAssetId = Boolean(item.id && item.id.trim() !== '');

    return hasAllowedEventType && hasAssetId;
  });
};
